/*!
 * Copyright 2022 Thorne Health Lab. All rights reserved.
 */
import { fork, all } from 'redux-saga/effects'
import apiSagas from '../api/sagas'

const sagas = [apiSagas]

function* rootSagas() {
  const rootSagasForks = sagas.map(saga => fork(saga))

  yield all([...rootSagasForks])
}

export default rootSagas
